
const SET_USERINFO = 'setUserInfo';
const SET_COMPANYINFO = 'setCompanyInfo';
export {
  SET_USERINFO,
  SET_COMPANYINFO
};
